import React from "react";
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
} from "react-bootstrap";

export default ({ entity, material, showEstimatedQuantities }) => (
  <div className="form-horizontal">
    {material.map((m) => (
      <FormGroup key={m.id}>
        <Col componentClass={ControlLabel} sm={6}>
          {m.name}
        </Col>
        <Col sm={6}>
          <FormControl.Static>
            {Math.round(m.quantity * 1000) / 1000}
            {m.label ? ` ${m.label}` : ""}
          </FormControl.Static>
        </Col>
      </FormGroup>
    ))}
    <HelpBlock className="text-center">
      {`Only scheduled ${
        entity === "purchaseOrders" ? "deliveries" : "jobs"
      } are included in material totals.`}
    </HelpBlock>
  </div>
);
